<template>
  <div class="simple-list-container">
    <source-dialog-form
      :value="content"
      :dialog-mode="false"
      @input="content = arguments[0]"
    ></source-dialog-form>
    <h4>Ссылка по ГОСТ:</h4>
    <base-text-copy
      :value="formattedLink"
      tooltip="Копировать текст ссылки"
    ></base-text-copy>
  </div>
</template>

<script>
import { getDefaultSourceData } from '@/shared/defaults.js'
import SourceDialogForm from '@/components/SourceDialogForm.vue'
import linkFormat from '@/shared/linkFormat'
import BaseTextCopy from '@/components/BaseTextCopy.vue'

export default {
  name: 'SimpleListContainer',

  components: {
    SourceDialogForm,
    BaseTextCopy
  },

  computed: {
    formattedLink () {
      return linkFormat(this.content)
    }
  },

  data () {
    return {
      content: getDefaultSourceData()
    }
  }
}
</script>

<style lang="sass" scoped>
h4
  text-align: left
</style>


// WEBPACK FOOTER //
// SimpleListContainer.vue?ba53a1b2